var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _text, _text2, _path13, _path14, _path15, _path16, _text3, _text4, _path17, _path18, _path19, _path20, _text5, _text6, _path21, _text7, _text8, _path22, _text9, _text0, _path23, _path24, _path25, _text1, _text10, _path26, _path27, _text11, _path28, _text12, _path29, _text13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem19Chtr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st1{fill:#333}.st2{fill:#7f7f7f}.st5{fill:#bfbfbf}.st7{fill:#fff}.st8{font-family:&apos;Arial-BoldMT&apos;}.st9{font-size:14.1912px}.st10{fill:#369;fill-opacity:.502}.st11{font-family:&apos;ArialMT&apos;}.st12{font-size:11.4815px}\n  ")), /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M388.7 77.8c-9.7-3-16.4-6.8-20.2-11.3v98.4c3.7 4.6 10.4 8.3 20.2 11.3V77.8z",
    className: "st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M471 66.9c-2.6 3.1-6.6 5.8-12.1 8.1v98.4c5.5-2.3 9.5-5 12.1-8.1V66.9z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399.8 80.3c-2.7-.5-5.4-1.1-8.1-1.8v98.4c2.7.7 5.4 1.3 8.1 1.8V80.3z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.9 81.2c-1.2-.1-2.4-.2-3.6-.4v98.4c1.2.2 2.4.3 3.6.4V81.2z",
    style: {
      fill: "#666"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M696.9 61.5l-25.7 19.2v98.4l25.7-19.4V61.5z",
    className: "st5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M617.4 81.6l-28.1-18.9v98.4l28.1 18.7V81.6z",
    style: {
      fill: "#1a1a1a"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M696.9 61.6l-28.2-18.7-53.8.5-25.5 19.2 28.1 18.9 53.8-.7 25.6-19.2z",
    className: "st7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M671.3 80.8l-53.8.7v98.2l53.8-.5V80.8z",
    className: "st2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M669.2 42.2l-.2-.2-54.5.5-.2.2L588.8 62l-.4.4v99.3l.4.2 28.1 18.7.4.2 54.3-.5.2-.2 25.7-19.4.4-.2V61.1l-.4-.2-28.3-18.7m-.8 1.6L696 62.1v97.3l-25.1 19-53.3.5-27.4-18.2V63.1l24.9-18.8 53.3-.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M420.7 81.9h.8c32.7-1.6 50.2-9.2 52.4-22.7-3.7-13.1-21.6-20.2-53.6-21.4h-1.6c-32.8 1.6-50.3 9.2-52.4 22.7 3.8 13.2 21.9 20.3 54.4 21.4z",
    className: "st7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M474.8 60v-.7c-.3-3.4-1.9-6.4-4.9-9-4.6-4.1-11.2-7.3-20-9.5-8.8-2.4-18.8-3.7-29.9-3.8h-1.4c-15.1.3-27.6 2.6-37.6 6.8-4.7 2-8.5 4.3-11.3 7-2.9 2.8-4.3 5.8-4.3 9v.7c.3 3.3 1.9 6.3 4.9 9 4.6 4 11.2 7.2 20 9.5 8.8 2.5 18.8 3.7 29.9 3.8h1.4c15.1-.3 27.5-2.6 37.4-6.8 4.9-2 8.8-4.3 11.5-7 2.8-2.7 4.2-5.7 4.3-9m-17.5-15.1c4.7 2 8.5 4.3 11.3 6.7 2.7 2.6 4.1 5.2 4.3 7.7v.7c0 2.6-1.3 5.2-3.8 7.7-4 3.8-10.1 6.9-18.5 9.4-8.3 2.4-18.1 3.7-29.1 4h-1.4c-14.9-.1-27.3-2.2-37.2-6.3-4.7-1.9-8.5-4-11.3-6.5-2.7-2.5-4.1-5.2-4.3-7.9v-.5c0-2.6 1.3-5.2 3.8-7.7 3.9-3.7 10.1-6.8 18.5-9.4 8.3-2.4 18-3.7 29.1-4h1.4c14.8.2 27.2 2.2 37.2 6.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 61.7l78.3 30.2 74.1-32-78.3-30.2-74.1 32z",
    className: "st7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M243.9 158.2V59.8l-74.1 32V190l74.1-31.8z",
    className: "st5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M169.8 91.7L91.5 61.5v98.2l78.3 30.2V91.7z",
    className: "st1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M244.8 59.3l-.7-.2L166 28.9l-.4-.2-74.5 32-.5.3v99.7l78.8 30.4.4.2 74.5-32.2.5-.2V59.3m-1.8 1.3v97.1l-73.2 31.6-77.4-29.9V62.1l73.2-31.4L243 60.6zM474.8 59.3c0-.6-.3-.9-.9-.9s-.9.3-.9.9v.7c0 2.6-1.3 5.2-3.8 7.7-4 3.7-10.1 6.8-18.5 9.4-8.3 2.4-18.1 3.7-29.1 4h-1.4c-14.9-.1-27.3-2.2-37.2-6.3-4.7-1.9-8.5-4.1-11.3-6.5-2.7-2.6-4.1-5.2-4.3-7.9-.2-.4-.5-.7-1.1-.7-.4 0-.7.3-.7.9V159c.3 3.2 1.9 6.2 4.9 9 4.6 4 11.2 7.1 20 9.5s18.8 3.7 29.9 3.8h1.4c15.1-.3 27.5-2.6 37.4-6.8 4.9-2 8.8-4.3 11.5-7 2.8-2.7 4.3-5.8 4.3-9.2v-99m-4.5 9.8c1-1 1.9-2.1 2.5-3.1v92.3c0 2.8-1.3 5.4-3.8 7.9-4 3.7-10.1 6.8-18.5 9.4-8.3 2.4-18.1 3.7-29.1 4h-1.4c-14.9-.2-27.3-2.3-37.2-6.3-4.7-1.9-8.5-4.1-11.3-6.5-2.7-2.6-4.1-5.2-4.3-7.9v-93c.8 1.3 1.8 2.5 3.1 3.7 4.6 4 11.2 7.1 20 9.5s18.8 3.7 29.9 3.8h1.4c15.1-.3 27.5-2.6 37.4-6.8 4.7-2 8.5-4.3 11.3-7zM306.5 154.7c1.4-3.7 3.3-7 5.6-9.9l-5.6 2-5.4-2c2.3 2.9 4.1 6.2 5.4 9.9zM312.1 73c-2.3-2.8-4.1-6.1-5.6-9.9-1.3 3.8-3.1 7.1-5.4 9.9l5.4-2 5.6 2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M312.1 73c-2.3-2.8-4.1-6.1-5.6-9.9-1.3 3.8-3.1 7.1-5.4 9.9l5.4-2 5.6 2zM305.1 122.1h2.9v25.6h-2.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M305.1 70.2h2.9v19.7h-2.9z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st8 st9",
    transform: "matrix(1.0001 0 0 1 302.8975 106.3618)"
  }, "\n    2\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st8 st9",
    transform: "matrix(1.0001 0 0 1 293.9004 118.4116)"
  }, "\n    \u516C\u5206\n  ")), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M169.9 189.4l-.4 1.4 5.2 2 .5-1.3-5.3-2.1m10.8 4.3l-.5 1.3 5.4 2.2.5-1.4-5.4-2.1m16.2 6.1l-5.4-2-.5 1.3 5.4 2.2.5-1.5m10.3 5.6l.4-1.4-5.2-2-.5 1.3 5.3 2.1zM244 157.5l-.5 1.3 5.4 2.2.5-1.3-5.4-2.2m10.8 4.1l-.5 1.4 5.4 2 .5-1.3-5.4-2.1m16 6.3l-5.4-2.2-.4 1.4 5.2 2 .6-1.2m10.3 5.4l.5-1.3-5.4-2.2-.5 1.4 5.4 2.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M148.4 198.5l-5.4 2.3.7 1.3 5.2-2.2-.5-1.4m-10.1 6l-.5-1.3-5.2 2.2.5 1.4 5.2-2.3m21.2-9.2l-.5-1.3-5.4 2.3.5 1.3 5.4-2.3m10.7-4.5l-.7-1.3-5.2 2.2.5 1.4 5.4-2.3zM70.2 168.2l-5.2 2.3.5 1.3 5.2-2.2-.5-1.4m-10.1 6l-.5-1.3-5.2 2.2.5 1.4 5.2-2.3m21.2-9.2l-.5-1.3-5.4 2.3.7 1.3 5.2-2.3m10.7-4.5l-.5-1.3-5.4 2.2.5 1.4 5.4-2.3zM319.2 158.9v-1.4h-25.5v1.4h25.5zM319.2 60.4V59h-25.5v1.4h25.5zM532.4 154.7c1.3-3.7 3.2-7 5.6-9.9l-5.6 2-5.4-2c2.2 2.9 4 6.2 5.4 9.9zM538 73c-2.4-2.8-4.3-6.1-5.6-9.9-1.4 3.8-3.2 7.1-5.4 9.9l5.4-2 5.6 2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M538 73c-2.4-2.8-4.3-6.1-5.6-9.9-1.4 3.8-3.2 7.1-5.4 9.9l5.4-2 5.6 2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M530.8 70.2h2.9v19.7h-2.9zM530.8 122.1h2.9v25.6h-2.9z"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st8 st9",
    transform: "matrix(1.0001 0 0 1 528.6475 106.3618)"
  }, "\n    2\n  ")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "st8 st9",
    transform: "matrix(1.0001 0 0 1 519.7002 118.4116)"
  }, "\n    \u516C\u5206\n  ")), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 204.4c-3.7-1.3-7-3.1-9.9-5.4l2 5.4-2 5.6c2.9-2.3 6.2-4.1 9.9-5.6zM377.7 204.4l2-5.4c-2.9 2.3-6.2 4.1-9.9 5.4 3.7 1.4 7 3.3 9.9 5.6l-2-5.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M377.7 204.4l2-5.4c-2.9 2.3-6.2 4.1-9.9 5.4 3.7 1.4 7 3.3 9.9 5.6l-2-5.6zM130.1 208.3c-1.4-1.9-2-3.9-1.6-5.9l-5 3.4-8.6 2.2c1.5-.1 3-.2 4.6-.2 3.9 0 7.5.2 10.6.5zM67.8 179.2c-5.6 0-10.8-.4-15.7-1.1 1.7 2.2 2.3 4.4 1.8 6.7l6.3-3.6 9.9-2h-2.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8 179.2c-5.6 0-10.8-.4-15.7-1.1 1.7 2.2 2.3 4.4 1.8 6.7l6.3-3.6 9.9-2h-2.3zM285.2 182.2c-.8-2.2-.7-4.2.5-6.1-4.1.7-8.5 1-13.4 1.1h-2.1l9 1.8 6 3.2zM222.9 203.7l-5.9-3.8c.2 2.6-.7 5.2-2.7 7.6 6-1 12.3-1.6 18.9-1.8l-10.3-2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M222.9 203.7l-5.9-3.8c.2 2.6-.7 5.2-2.7 7.6 6-1 12.3-1.6 18.9-1.8l-10.3-2zM376.5 203h26.4v2.9h-26.4zM437.4 203h26v2.9h-26z"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "st8 st9",
    transform: "matrix(1.0001 0 0 1 416.4473 206.0117)"
  }, "\n    2\n  ")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "st8 st9",
    transform: "matrix(1.0001 0 0 1 407.4502 220.9614)"
  }, "\n    \u516C\u5206\n  ")), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M280.7 179.9l-1.3-2.5-8.8 3.9v3.1zM221.3 202.9l1.3 2.7 13.5-6v-3.2z"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "st8 st9",
    transform: "matrix(1.0001 0 0 1 249.6475 192.4614)"
  }, "\n    2\n  ")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "st8 st9",
    transform: "matrix(1.0001 0 0 1 240.6001 207.4614)"
  }, "\n    \u516C\u5206\n  ")), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7 179.7l-.9 2.7 12.9 5v-3.1zM124.8 204.7l-18.4-7.1v3.1l17.5 6.7z"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "st8 st9",
    transform: "matrix(1.0001 0 0 1 85.4473 192.4614)"
  }, "\n    2\n  ")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    className: "st8 st9",
    transform: "matrix(1.0001 0 0 1 76.4502 207.4614)"
  }, "\n    \u516C\u5206\n  ")), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M693.4 204.4c-3.7-1.3-7-3.1-9.9-5.4l2 5.4-2 5.6c3-2.3 6.3-4.1 9.9-5.6zM600.6 204.4l2-5.4c-2.9 2.3-6.2 4.1-9.9 5.4 3.7 1.4 7 3.3 9.9 5.6l-2-5.6z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M600.6 204.4l2-5.4c-2.9 2.3-6.2 4.1-9.9 5.4 3.7 1.4 7 3.3 9.9 5.6l-2-5.6zM660.2 203h26.1v2.9h-26.1z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M599.6 203h26.1v2.9h-26.1z"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    className: "st8 st9",
    transform: "matrix(1.0001 0 0 1 639.4473 206.0117)"
  }, "\n    2\n  ")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "st8 st9",
    transform: "matrix(1.0001 0 0 1 630.4004 220.9614)"
  }, "\n    \u516C\u5206\n  ")), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M545.1 158.9v-1.4h-25.7v1.4h25.7zM545.1 60.4V59h-25.7v1.4h25.7zM367 205.1v-33.6h-1.4v33.6h1.4zM474.6 205.1v-33.6h-1.4v33.6h1.4zM589.8 205.1v-33.6h-1.4v33.6h1.4zM697.7 205.1v-33.6h-1.4v33.6h1.4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M175.4 53c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st10"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "st7 st11 st12",
    transform: "matrix(.9981 0 0 1 162.8672 66.5679)"
  }, "\n    1\n  ")), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M427.3 53c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7s5.3 3.6 8.7 3.6c3.4 0 6.2-1.2 8.6-3.6s3.6-5.3 3.6-8.7c0-3.4-1.2-6.3-3.6-8.7z",
    className: "st10"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "st7 st11 st12",
    transform: "matrix(.9981 0 0 1 414.7676 66.5679)"
  }, "\n    2\n  ")), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M653.4 53c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st10"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "st7 st11 st12",
    transform: "matrix(.9981 0 0 1 640.917 66.5679)"
  }, "\n    3\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem19Chtr);
export default __webpack_public_path__ + "static/media/item19chtr.091981780707b57b6da5ad841b2c9ff4.svg";
export { ForwardRef as ReactComponent };